import { proxy } from "valtio";
import { useSnapshot } from "valtio/react";

type PassengerSelectorState = {
  selected_seats_count: number;
};

const passenger_store = proxy<PassengerSelectorState>({
  selected_seats_count: 1
});

export const usePassengerStore = () => {
  return useSnapshot(passenger_store);
};

export const addPassenger = () => {
  passenger_store.selected_seats_count++;
};
export const removePassenger = () => {
  passenger_store.selected_seats_count--;
};
